import { useState, useEffect } from 'react';
import { State, Store } from './State';

let store: Store;

/**
 * This is exported mainly for test environment setups etc. Prefer
 * using `browserRender` or `serverRender` whenever possible.
 */
export function setupScopeStateHooks(s: Store) {
  store = s;
}

function createScopeStateHook<TState>(selector: (state: State) => TState) {
  return (() => {
    const [currentValue, setCurrentValue] = useState(selector(store.getState()));

    useEffect(() => {
      let previousValue = selector(store.getState());
      const unsubscribe = store.subscribe(() => {
        const value = selector(store.getState());
        if (value !== previousValue) {
          previousValue = value;
          setCurrentValue(value);
        }
      });
      return () => unsubscribe();
    }, []);

    return currentValue;
  }) as TState extends object ? <TValue extends TState>() => TValue : () => TState;
}

export const useCurrentBreakpoint = createScopeStateHook(state => state.currentBreakpoint);
export const useAppShellData = createScopeStateHook(state => state.appShellData);
export const useCurrentPage = createScopeStateHook(state => state.currentPage);
export const useCurrentTheme = createScopeStateHook(state => state.currentTheme);
export const useSpinner = createScopeStateHook(state => state.spinner);
